import React from 'react';

const Card = ({ className, children, padding = 'p-12', rounded = 'rounded-lg' }) => (
  <div
    className={`${padding} ${rounded} border border-solid border-gray-200 ${className}
      transition duration-300 transform hover:-translate-y-1 hover:scale-110
    `}
    style={{
      boxShadow: '0 10px 28px rgba(0,0,0,.08)'
    }}
  >
    {children}
  </div>
);

export default Card;
